import { useSyncExternalStore } from 'react';
import { create } from 'zustand';

import { Profile } from '@paragon/contract-library';

const mousyProfileState = create<{ profile: Profile } | null>(() => null);

export const useMousyProfile = () => useSyncExternalStore(mousyProfileState.subscribe, getMousyInsertionProfile);

export function getMousyInsertionProfile(): Profile | null {
  return mousyProfileState.getState()?.profile ?? null;
}

export function setMousyInsertionProfile(profile: Profile): void {
  mousyProfileState.setState({ profile });
}

export function resetMousyInsertionProfile(): void {
  if (mousyProfileState.getState() != null) {
    mousyProfileState.setState(null, true);
  }
}

export const subscribeToMousyInsertionProfileChanges = mousyProfileState.subscribe;
